import React, { useState } from "react";

const ArtprintsViewAllCards = ({ ImgSrc, ImgJpg, ImgJpeg, title, desc, isDesktop, item, showWishlistButton }) => {
  const [currentImg, setCurrentImg] = useState(ImgSrc);
  const [loaded, setLoaded] = useState(false); // Track when image loads
  const [imageError, setImageError] = useState(false); // Track if primary image failed

  const imageWrapperClass = `aspect-square w-full overflow-hidden rounded-xl relative group transition-shadow duration-500 ${
    loaded ? 'shadow-xl shadow-gray-400' : 'shadow-none'
  }`;

  const imageClass = `w-full h-full object-contain rounded-xl transition-all duration-300 group-hover:scale-105 group-hover:rounded-none`;

  // Handle image load error and fallback to jpeg
  const handleImageError = () => {
    if (!imageError && ImgJpeg) {
      setCurrentImg(ImgJpeg);
      setImageError(true);
    }
  };

  // Handle successful image load
  const handleImageLoad = () => {
    setLoaded(true);
  };

  const desktopWrapper = (
    <div className="w-[350px] lg:w-[380px]">
      <button className="w-full">
        <div className={imageWrapperClass}>
          <img
            className={imageClass}
            src={currentImg}
            alt={title}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </div>
        <div className="p-3 text-center">
          <p className="text-gray-500 text-xs pt-0">{title}</p>
          <p className="text-gray-700 text-base pt-0">{desc}</p>
        </div>
      </button>
    </div>
  );

  const mobileWrapper = (
    <div className="w-full">
      <button className="w-full">
        <div className={imageWrapperClass}>
          <img
            className={imageClass}
            src={currentImg}
            alt={title}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </div>
        <div className="p-2 text-center">
          <p className="text-gray-500 text-xs pt-0">{title}</p>
          <p className="text-gray-800 text-base pt-0">{desc}</p>
        </div>
      </button>
    </div>
  );

  return isDesktop ? desktopWrapper : mobileWrapper;
};

export default ArtprintsViewAllCards;















// import React, { useState } from "react";

// const AbstractCards = ({ ImgSrc, title, btn, desc }) => {
//   const [currentImg] = useState(ImgSrc);

//   return (
//     <div className="bg-white h-full w-full">
//       <div className="overflow-hidden rounded-xl relative group">
//         <img
//           className="w-full h-[180px] sm:h-[300px] object-cover rounded-xl transition-transform duration-300 ease-in-out transform hover:scale-110 group-hover:scale-110 group-hover:rounded-none"
//           src={currentImg}
//           alt={title}
//         />
//         {/* Overlay for "Vizaura" */}
//           {/* <div className="absolute inset-0 flex justify-end items-end">
//             <h2 className="text-4xl font-bold text-white opacity-30 pr-16 pb-5">Vizaura</h2>
//           </div> */}
//       </div>
//       <div className="p-2 sm:p-4">
//       <h3 className="text-sm sm:text-xl font-semibold text-gray-800 mb-1 sm:mb-2">{title}</h3>
//       <p className="text-xs sm:text-base text-gray-600 mb-2 sm:mb-4">{desc}</p>
//         {btn && (
//           <button className="bg-gray-800 text-white px-2 py-1 sm:px-4 sm:py-2 text-sm sm:text-base rounded-md hover:bg-gray-700 transition-colors duration-300">
//             {btn}
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AbstractCards;










// import React, { useState } from "react";

// const ServicesCards = ({ ImgSrc, title, desc, btn, hoverImg }) => {
//   const [currentImg, setCurrentImg] = useState(ImgSrc);

//   const handleMouseEnter = () => {
//     setCurrentImg(hoverImg);
//   };

//   const handleMouseLeave = () => {
//     setCurrentImg(ImgSrc);
//   };

//   return (
//     <div className="h-auto w-auto">
//       <button>
//         <div className="w-[400px] h-[380px] px-10 pl-10"> {/* Fixed height for the image container */}
//         <img
//             className="w-full h-full object-cover rounded-3xl"
//             src={currentImg}
//             alt={title}
//             onMouseEnter={handleMouseEnter}
//             onMouseLeave={handleMouseLeave}
//           />
//         </div>
//         <div className="h-[94px] p-2 text-center">
//           <p className="text-gray-700 text-sm pt-0">{title}</p>
//           <p className="font-semibold text-[#000000] text-lg">{desc}</p>
//         </div>
//       </button>
//     </div>
//   );
// };

// export default ServicesCards;